var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"readability-matters-site"}},[_vm._m(0),_c('Sandbox')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('a',{attrs:{"id":"logo-link","href":"https://readabilitymatters.org/"}},[_c('img',{attrs:{"src":require("./assets/images/rm-2024.png")}})])])
}]

export { render, staticRenderFns }